import Picture from './Picture';
import UserPicture from './UserPicture';
import ProductImage from './ProductImage';
import UserPlaceholder from './UserPlaceholder';

export {
  Picture,
  UserPicture,
  ProductImage,
  UserPlaceholder,
};



// WEBPACK FOOTER //
// ../src/client/components/images/index.js